import { postCall, getCall, putCall, deleteCall, downloadCall } from "./api";

// ---- Salary components (catalog) ----
export const getSalaryComponents = async (legalUnit) =>
  await getCall({ path: `/salary-component/${legalUnit}` });

export const createSalaryComponent = async (input = {}) =>
  await postCall({ path: `/salary-component`, bodyParams: input });

export const updateSalaryComponent = async (id, input = {}) =>
  await putCall({ path: `/salary-component/${id}`, bodyParams: input });

// ---- Salary templates ----
export const getSalaryTemplates = async (legalUnit) =>
  await getCall({ path: `/salary-template/${legalUnit}` });

export const getSalaryTemplateById = async (id) =>
  await getCall({ path: `/salary-template/id/${id}` });

export const createSalaryTemplate = async (input = {}) =>
  await postCall({ path: `/salary-template`, bodyParams: input });

export const updateSalaryTemplate = async (id, input = {}) =>
  await putCall({ path: `/salary-template/${id}`, bodyParams: input });

// ---- Statutory components ----
export const getStatutoryComponents = async (legalUnit) =>
  await getCall({ path: `/statutory-component/${legalUnit}` });

export const createStatutoryComponent = async (input = {}) =>
  await postCall({ path: `/statutory-component`, bodyParams: input });

export const updateStatutoryComponent = async (id, input = {}) =>
  await putCall({ path: `/statutory-component/${id}`, bodyParams: input });

// ---- Salary structure (per employee) ----
export const getAllSalaryStructures = async () =>
  await getCall({ path: `/salary-structure` });

export const getStructureByEmployee = async (employeeId) =>
  await getCall({ path: `/salary-structure/employee/${employeeId}` });

export const getSalaryRevisions = async (employeeId) =>
  await getCall({ path: `/salary-structure/revisions/${employeeId}` });

export const saveSalaryStructure = async (input = {}) =>
  await postCall({ path: `/salary-structure`, bodyParams: input });

export const deleteSalaryStructure = async (id) =>
  await deleteCall({ path: `/salary-structure/${id}` });

// ---- Payroll runs ----
export const getPayrollRuns = async () =>
  await getCall({ path: `/payroll/run` });

export const getPayrollRunById = async (id) =>
  await getCall({ path: `/payroll/run/${id}` });

export const createPayrollRun = async (input = {}) =>
  await postCall({ path: `/payroll/run`, bodyParams: input });

// input: { month, year, label, lines: [{ employee, adjustments:[{name,amount,type}] }] }
export const createOffCycleRun = async (input = {}) =>
  await postCall({ path: `/payroll/run/off-cycle`, bodyParams: input });

// input: { status: "approved" | "rejected", notes }
export const reviewPayrollRun = async (id, input = {}) =>
  await postCall({ path: `/payroll/run/${id}/review`, bodyParams: input });

// input: { items: [{ employee, lopDays, adjustments:[{name,amount,type}] }] }
export const updatePayrollRunItems = async (id, input = {}) =>
  await putCall({ path: `/payroll/run/${id}`, bodyParams: input });

export const markPayrollRunPaid = async (id, input = {}) =>
  await postCall({ path: `/payroll/run/${id}/pay`, bodyParams: input });

// bank-advice CSV download URL (browser GET with auth handled by the app shell)
// Built and downloaded server-side. The file is made of account numbers, and
// the browser has no business holding those to produce it — the server already
// has the run and the employees, and logs the export against the run.
export const downloadRunBankFile = async (id) =>
  await downloadCall({ path: `/payroll/run/${id}/bank-file` });

export const resyncRunExpenses = async (id) =>
  await postCall({ path: `/payroll/run/${id}/resync-expenses`, bodyParams: {} });

export const getRunAuditLog = async (id) =>
  await getCall({ path: `/payroll/run/${id}/audit` });

// ---- Leave encashment ----
export const requestEncashment = async (input = {}) =>
  await postCall({ path: `/leave-encashment`, bodyParams: input });

export const getSelfEncashments = async () =>
  await getCall({ path: `/leave-encashment/self` });

export const getAllEncashments = async (status) =>
  await getCall({ path: `/leave-encashment${status ? `?status=${status}` : ""}` });

export const getEncashmentById = async (id) =>
  await getCall({ path: `/leave-encashment/${id}` });

export const reviewEncashment = async (id, input = {}) =>
  await postCall({ path: `/leave-encashment/${id}/review`, bodyParams: input });

// ---- Payslips ----
export const getSelfPayslips = async () =>
  await getCall({ path: `/payroll/payslip/self` });

export const getPayslipsByEmployee = async (employeeId) =>
  await getCall({ path: `/payroll/payslip?employeeId=${employeeId}` });

export const getAllPayslips = async () =>
  await getCall({ path: `/payroll/payslip` });

export const getPayslipById = async (id) =>
  await getCall({ path: `/payroll/payslip/${id}` });

// ---- Payslip queries / disputes ----
export const raisePayslipQuery = async (input = {}) =>
  await postCall({ path: `/payslip-query`, bodyParams: input });

export const getSelfPayslipQueries = async () =>
  await getCall({ path: `/payslip-query/self` });

export const getAllPayslipQueries = async (status) =>
  await getCall({ path: `/payslip-query${status ? `?status=${status}` : ""}` });

export const getPayslipQueryById = async (id) =>
  await getCall({ path: `/payslip-query/${id}` });

export const replyPayslipQuery = async (id, body) =>
  await postCall({ path: `/payslip-query/${id}/reply`, bodyParams: { body } });

// input: { status: "resolved" | "rejected", resolution }
export const resolvePayslipQuery = async (id, input = {}) =>
  await postCall({ path: `/payslip-query/${id}/resolve`, bodyParams: input });
